import React, { Component } from 'react';
import TinkerGrounds from './TinkerGrounds';

class Main extends Component {
  
  constructor() {
    
    super();
    this.exampleRef = React.createRef();

  }

  render() {

    if ( window.isMobile ) {
         
         window.addEventListener('scroll', (e) => { e.preventDefault(); }, {passive: false});
         window.addEventListener('touchmove', (e) => { if (e.scale !== 1) e.preventDefault(); }, {passive: false});
         
    }

    let textureArray = [  [ ['./lightProbe/posx.jpg', './lightProbe/negx.jpg', './lightProbe/posy.jpg', './lightProbe/negy.jpg', './lightProbe/posz.jpg', './lightProbe/negz.jpg'], "lightProbe" ]                                        
                       ];     
    
    return (
      <div>
        <TinkerGrounds ratioDivisor="0.7" weakDeviceRatioDivisor="0.8" textures={textureArray} />
      </div>
    );
  }
}

export default Main;
